import { useState } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import { PRODUCT_SHIP_TYPE, SEO_STATUS } from '@vzmi/shp_shared_compo/constants/proposal'
import { awsConfig } from '@vzmi/ec_file_uploader_sdk'
import styles from './Editor.css'
import { When } from '../../../../Common/Form'
import MCEEditorField from '../MCEEditorField'
import { Field } from '../../../../Common/forms'
import { productCopyValidation } from '../Shared/validation/validations'
import { IconPopoverLabel } from '../FormLabelTooltip/FormLabelTooltip'
import { getCurrentSEOStatus } from '@vzmi/shp_shared_compo/helpers/proposalHelpers'
import SEOCheck from '../SEOCheck'

const Editor = props => {
  const {
    readOnly,
    fieldName = 'product.copy',
    shipType,
    className,
    isCloneListing = false,
    copy,
    isBatchApply = false,
    isEditPage = false,
    isNewListing = false,
    isNewProduct = false,
    withYouTubeCover = false
  } = props
  const shipTypeId = +_.get(shipType, 'id')
  // 預設吃 ec_file_uploader_sdk 設定
  // 只有複製賣場時配合 API 阻擋自訂允許圖片只接受指定的路徑 bp(beta), mm(prod)
  const imagePathPrefixes = isCloneListing ? ['bp', 'mm'] : awsConfig.imgPathPrefix
  const currentSEOStatus = _.isEmpty(copy)
    // 若詳情為空狀態直接顯示`詳情不符合 SEO 規範`
    ? SEO_STATUS.NON_COMPLIANT_PENDING
    : getCurrentSEOStatus(copy)

  // 新增一般賣場/新增屬性商品，頁面載入時不應該顯示檢核， OnBlur 離開後才需顯示
  // 其餘像修改詳情/批次修改詳情/複製賣場，進入提案頁，需檢查並顯示
  const isNotInitShowUI = !(isNewListing || isNewProduct) || isCloneListing
  const [onBlurStatus, setOnBlurStatus] = useState(isNotInitShowUI)

  const handleBlur = () => {
    setOnBlurStatus(true)
  }

  return (
    <div
      className={cx(
        styles.Editor,
        { [className]: className }
      )}
      data-role='editor'
    >
      <When
        value={isEditPage}
        isTrue
      >
        <div className={styles.info}>
          <p>
            <IconPopoverLabel
              className={styles.formLabel}
              align='sub'
              popoverContent={(
                <>
                  不要只放上圖而不放文字說明(即使圖上有壓字也一樣，因搜尋引擎無法讀取圖片上的文字，會影響SEO流量)。
                  <br />
                  也請避免只有文字而沒有圖，至少上傳一張圖片。
                </>
              )}
            >
              • 圖文並茂
            </IconPopoverLabel>
          </p>
          <p>
            <IconPopoverLabel
              className={styles.formLabel}
              align='sub'
              popoverContent='譬如：生活傢俱，可提供組裝方式、受歡迎與適用的擺放方式，常用的問與答、或是收納方式。'
            >
              • 內容圖文建議至少100-200字，可幫助用戶了解商品的特色、規格、潮流、最新資訊、適合風格
            </IconPopoverLabel>
          </p>
          <p> • 圖片檔案格式：JPG, JPEG, PNG, GIF。</p>
        </div>
      </When >
      {/* SEO 驗證顯示，限制於編輯頁、非批次套用區、 onBlur 後才需顯示 */}
      <When
        value={isEditPage && !isBatchApply && onBlurStatus}
        isTrue
      >
        <SEOCheck
          status={currentSEOStatus}
          copy={copy}
        />
      </When>
      <Field
        name={fieldName}
        readOnly={readOnly}
        component={MCEEditorField}
        mustShowFormError
        showErrorOnActive
        hideErrorOnEmptyInput
        isImageListBtnVisible={shipTypeId === PRODUCT_SHIP_TYPE.EXPRESS_24HR}
        customImgPathPrefixes={imagePathPrefixes}
        validate={productCopyValidation(imagePathPrefixes)}
        onBlur={handleBlur}
        withYouTubeCover={withYouTubeCover}
        withReadonlyToolbar={isEditPage}
        withLoaderContent={isEditPage}
      />
    </div >
  )
}

export default Editor
